const navItemsStockists = document.querySelectorAll('.stockists__section .nav-item a');
const label = document.querySelector('.select__label span');


navItemsStockists.forEach(navItem => {
    navItem.addEventListener('click', function (e) {
        e.preventDefault();
        if(navItem.classList.contains('active')) return;
        navItemsStockists.forEach(navItem => {
            navItem.classList.remove('active');
        })
        navItem.classList.add('active');
        let currentNavAtt = navItem.getAttribute('data-toggle')
        label.innerHTML = navItem.innerHTML;
        let allElement = document.querySelectorAll('[data-item]');
        allElement.forEach(element => {
            if(Number(element.getAttribute('data-item')) === Number(currentNavAtt)) {
                element.classList.add('active');
            } else if (Number(currentNavAtt) === 0) {
                element.classList.add('active');
            } else {
                element.classList.remove('active');
            }
        })
    })
})

if(window.innerWidth < 750) {
    console.log(window.innerWidth)
    const selectWrapper = document.querySelector('.stockists-region-list');
    let listWrapper = selectWrapper.querySelector('.naw-list__wrapper');
    let heightAnimate = listWrapper.clientHeight;
    listWrapper.style.maxHeight = '0';

    selectWrapper.addEventListener('click', function (event) {
        let parent = event.target.parentNode;
        if(event.target.classList.contains('select__label') || parent.classList.contains('select__label')) {
            listWrapper.classList.toggle('active');
            if(listWrapper.classList.contains('active')) {
                listWrapper.style.maxHeight = heightAnimate + 20 + 'px';
            } else {
                listWrapper.style.maxHeight = '0';
            }
        }
        if(event.target.classList.contains('nav-item') || parent.classList.contains('nav-item')){
            listWrapper.classList.remove('active');
            listWrapper.style.maxHeight = '0';
        }
    });
}

